<template>
  <router-view />
  <AuthModal />
  <GlobalAtmosphere />
</template>

<script setup lang="ts">
import AuthModal from "@/components/AuthModal.vue";
import GlobalAtmosphere from "@/components/GlobalAtmosphere.vue";
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  min-height: 100%;
}
</style>
